export default "__VITE_ASSET__CxRzANEL__"